/* as.if Musikredaktion, 16.09.2026: Hoerproben in Artikeln laden erst beim Klick.
   Link <a data-asif-youtube="VIDEO_ID"> in .asif-editorial-track. Ohne Skript fuehrt der Link zu YouTube.
   Beim Start pausiert das as.if.radio, damit nicht zwei Quellen gleichzeitig laufen. */
(() => {
  if (window.__asifEditorialMedia) return;
  window.__asifEditorialMedia = true;
  const VALID_ID = /^[A-Za-z0-9_-]{11}$/;

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('a[data-asif-youtube]');
    if (!link) return;
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const id = link.getAttribute('data-asif-youtube') || '';
    if (!VALID_ID.test(id)) return;
    event.preventDefault();

    const card = link.closest('.asif-editorial-track') || link.parentElement;
    let slot = card.querySelector(':scope > .asif-editorial-track__player');
    const existing = slot && slot.querySelector('iframe');
    if (existing) {
      existing.focus({ preventScroll: true });
      return;
    }
    if (!slot) {
      slot = document.createElement('div');
      slot.className = 'asif-editorial-track__player';
      card.appendChild(slot);
    }

    try {
      if (window.AsIfRadio && typeof window.AsIfRadio.pause === 'function') window.AsIfRadio.pause();
    } catch (error) { /* Radio ist optional */ }

    const frame = document.createElement('iframe');
    frame.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`;
    frame.title = link.getAttribute('data-asif-title') || 'Hörprobe auf YouTube';
    frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
    frame.allowFullscreen = true;
    frame.referrerPolicy = 'strict-origin-when-cross-origin';
    slot.appendChild(frame);

    link.setAttribute('aria-expanded', 'true');
    const label = link.querySelector('[data-asif-label]');
    if (label) label.textContent = 'Läuft';
  });
})();
